import { Alert, Card, Container } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useCallback, useEffect, useState } from "react";
import api from "../../../../service/api";
import { useLocation } from "react-router-dom";
import { Search } from "./UnpaidInvoices/Search";
import { tableColumns } from "./UnpaidInvoices/data";
import { Lists } from "./UnpaidInvoices/Lists";
import download from "downloadjs";
import { SnackbarAlert } from "../../../../components/SnackbarAlert";
import dayjs from "dayjs";


const UnpaidInvoiceReport = () => {
    const [loading, setLoading] = useState([]);
    const [error, setError] = useState();
    const [notif, setNotif] = useState({
        notifMsg: "",
        open: false,
        severity: "success",
    });
    const [data, setData] = useState([]);
    const location = useLocation();
    const state = location.state;
    const [searchValue, setSearcValue] = useState({
        start_date: "2024-01-01",  // string format
        end_date: dayjs().format("YYYY-MM-DD"), // today as string
        company: "",
    });
    const [companyName, setCompanyName] = useState("");

    const search = (page) => {
        const searchParam = { ...searchValue, ...page };
        setSearcValue(searchParam);
        getInvoices(searchParam);
    };
    const getInvoices = useCallback(async (search) => {
        try {
            setError("")
            setLoading(true);
            const response = await api.get(
                "tms/invoices/unpaid-invoice-by-customer",
                search
            );
            setData(response);
        } catch (error) {
            setError(error.message || "An error occured during fetching of data.")
            setLoading(false);
            return null;
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        let pageNo = "";
        if (state?.page) {
            pageNo = state?.page;
        }

        const searchParam = { ...searchValue, };

        getInvoices(searchParam);
    }, [getInvoices, state?.page]);

    const generateUnpaidInvoiceReport = async () => {
        try {
            setError("");
            setLoading(true);

            const response = await api.getexcel(
                "tms/export-excel-unpaid-invoices",
                searchValue
            );


            if (response.type === "application/json") {

                const text = await response.text();
                const jsonData = JSON.parse(text);

                if (jsonData.success && jsonData.message) {
                    setNotif({
                        notifMsg: jsonData.message,
                        open: true,
                        severity: "success",
                    });
                    return;
                }

                if (jsonData.meta?.total === 0) {
                    setError(jsonData.message || "No data to be exported");
                    return;
                }

                if (jsonData.error) {
                    setError(
                        jsonData.error || "An error occurred during export"
                    );
                    return;
                }
            }

            const { start_date, end_date } = searchValue;

            const parts = ["unpaid-invoices"];

            if (companyName) {
                parts.push(companyName.replace(/\s+/g, "_"));
            }

            if (start_date || end_date) {
                const formattedStart = start_date
                    ? start_date.replaceAll("-", "")
                    : "";
                const formattedEnd = end_date
                    ? end_date.replaceAll("-", "")
                    : "";
                const datePart =
                    formattedStart && formattedEnd
                        ? `${formattedStart}-${formattedEnd}`
                        : formattedStart || formattedEnd;
                parts.push(datePart);
            }

            const filename = parts.filter(Boolean).join("_") + ".xlsx";

            download(response, filename);
            setNotif({
                notifMsg: "Unpaid Invoices Exported Successfully!",
                open: true,
                severity: "success",
            });
        } catch (error) {
            console.error(error);
            setError(error.message || "An error occurred during export");
        } finally {
            setLoading(false);
        }
    };

    let helmentTitle = "Unpaid Invoice Summary by Customer";

    return (
        <>
            <Helmet title={helmentTitle} />
            <Container fluid className="p-0">
                <h1 className="h3 mb-3">Unpaid Invoice Summary by Customer</h1>
            </Container>
            <Card>
                <Card.Header>
                    <Search
                        search={search}
                        setSearchValue={setSearcValue}
                        searchValue={searchValue}
                        setCompanyName={setCompanyName}
                        companyName={companyName}
                        generateReport={generateUnpaidInvoiceReport}
                    />
                    {error && (
                        <Alert className="my-3" variant="danger">
                            <div className="alert-message">{error}</div>
                        </Alert>
                    )}
                </Card.Header>
                <Card.Body className="mt-0">
                    {loading && <div>Loading...</div>}
                    {!loading && data?.data && (
                        <Lists
                            columns={tableColumns}
                            rawData={data}
                            pagination={search}
                        />
                    )}
                </Card.Body>
            </Card>
            <SnackbarAlert notif={notif} setNotif={setNotif} />
        </>
    );
};

export default UnpaidInvoiceReport;
